module.exports = __webpack_public_path__ + "img/IMG_1039_L_BlackMatted.b20164a8.jpg";